export default __webpack_public_path__ + "static/media/3_MontajFiiliAdetÖrnekExceli.9c4050ad.xlsx";